import React from "react";
import { Link } from "react-router-dom";
import "../global.css";

import * as ROUTES from "../../constants/routes";

const Landing = () => (
  <div>
    <div className="centered-content text-left">
      <h1 className="header-title">Timeline</h1>
      <p className="landing-quotes">
        The paths not taken are infinite, the path taken is one.
      </p>
      <p className="landing-quotes">Now is now the same now as just now.</p>
      <p className="landing-quotes">
        Today is the first day of the rest of your life.
      </p>
      <p className="landing-quotes">You’ll never be as young as you are now.</p>
      <p className="landing-quotes">
        + some other time quotes that may be too intense to end up here
      </p>
      <br />
      <Link to={ROUTES.SIGN_UP}>
        <p>See your time in time now</p>
      </Link>
    </div>
  </div>
);
export default Landing;
